import { createAction } from 'redux-actions'
import { createRequestActions as request } from 'store/actionCreators'

export const getLevels = request('LEVELS/GET', protrackId => ({
  request: {
    url: `/protracks/${protrackId}/protracks-levels`,
  },
}))

export const postLevelsList = request('LEVELS/POST_LIST', data => ({
  request: {
    url: `/protracks/${data.protrackId}/protracks-levels/update-order`,
    method: 'POST',
    data: data.values,
  },
}))

export const createLevel = request('LEVELS/POST', ({ values, protrackId, typeOfLevel }) => ({
  request: {
    url: `/protracks/${protrackId}/protracks-levels/`,
    method: 'POST',
    data: { ...values, typeOfLevel },
  },
}))

export const updateLevel = request('LEVELS/PUT', ({ values, protrackId, levelId, typeOfLevel }) => {
  delete values.active
  return {
    request: {
      url: `/protracks/${protrackId}/protracks-levels/${levelId}`,
      method: 'PUT',
      data: { ...values, typeOfLevel },
    },
  }
})

export const publishLevel = request('LEVELS/PATCH', ({ protrackId, levelId }) => ({
  request: {
    url: `/protracks/${protrackId}/protracks-levels/${levelId}`,
    method: 'PATCH',
  },
  success: 'Level was successfully published!',
}))

export const setView = createAction('LEVELS/SET_VIEW', id => ({ id }))

export const setOrder = createAction('LEVELS/SET_ORDER', (list, oldIndex, newIndex) => ({
  list,
  oldIndex,
  newIndex,
}))

export const setDeleted = createAction('LEVELS/SET_DELETED', (id, isDeleting) => ({
  id,
  isDeleting,
}))

export const setBeforeCreateOrder = createAction('LEVELS/SET_BEFORE_CREATE_ORDER', order => ({ order }))
